import EventTrackingTdvEventsMixin from "./eventTrackingTdvEventsMixin";


/* Creates a new instance of a basic lead Tracking Event to track users events when the user subimits a lead.
 this class contains all the events that needs be to be done.
*/
export default class BasicLeadTrackingEvents {
    constructor(model) { 
      const data = {...model, eventLabel: 'Search-CTA-Learn-More'}
      this.events = {};
      this.events.googleAnalytics = [
        new EventTrackingTdvEventsMixin(data)];
    }
  }